import { jsx as _jsx } from "react/jsx-runtime";
import { CatHeading } from '@blocks-react/components/Heading';
import cx from 'classnames';
import styles from './HeaderWaffleMenuTitle.module.scss';
export const HeaderWaffleMenuTitle = ({ title, }) => {
    return (_jsx(CatHeading, { variant: "title", children: _jsx("span", { className: cx('text-capitalize', styles['header__waffle-menu-title']), "data-testid": "cat-waffle-menu-title", children: title }) }));
};
